<div class="menu-option">
  <ng-content></ng-content>
  <img *ngIf="img" [src]="img"/>
  <label *ngIf="label">{{label}}</label>
</div>
